var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { convertSiteLevelMetaTags } from '../../converters/convert-site-level-meta-tags';
import { getUserPatternByItemType } from '../../patterns/get-user-pattern-by-item-type';
import { getContext } from '../../tags/context/get-context';
import { STATIC_PAGE_V2 } from '../../types/ItemTypes';
import { filterPageLevelTags } from '../../tags/filters/filter-page-level-tags';
import { getAdapter } from '../../adapters-async';
import { convertSeoModel } from '../../converters/convert-seo-model';
import { resolveWithPatterns } from '../resolve-with-patterns';
import { getDefaultItemPayload } from '../../patterns/get-default-item';
import { handleOldBlog } from '../../item-types/blog-post/handleOldBlogPost/handle-old-blog-post';
import { CONTEXT_PROPS } from '../../types/ContextProps';
import { filterPayloadWithoutVelo } from '../../tags/filters/filter-payload-without-velo';
import { convertComponentsItemPayload } from '../convert-components-item-payload';
import { getDefaultPatternsSchemas } from '../get-default-patterns-schemas-async';
import { getDynamicPatternsSchema } from '../get-dynamic-patterns-schema';
import { getMultilingualSchemaFromContext } from '../get-multilingual-tags';
import { hasAdapterMultilingualData } from '../has-adapter-multilingual-data';
function _getEditorPayload(context, pageLevelSeoData) {
    return __awaiter(this, void 0, void 0, function () {
        var editorPanelLegacyData, editorPanelPageData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAdapter(STATIC_PAGE_V2)];
                case 1:
                    editorPanelLegacyData = (_a.sent()).getLegacySeoBlob({
                        context: context,
                    });
                    editorPanelPageData = convertSeoModel(pageLevelSeoData.advancedSeoData);
                    return [2 /*return*/, [editorPanelLegacyData, editorPanelPageData]];
            }
        });
    });
}
function _getUserPatternPayload(siteLevelSeoData, itemType, options) {
    if (options === void 0) { options = { logError: function () { } }; }
    var userPatternSchema = getUserPatternByItemType(siteLevelSeoData.userPatterns, itemType, options);
    var _a = itemType === STATIC_PAGE_V2
        ? [userPatternSchema, {}]
        : [{}, userPatternSchema], userStaticPatternSchema = _a[0], userDynamicPatternSchema = _a[1];
    return {
        userPatternSchema: userPatternSchema,
        userStaticPatternSchema: userStaticPatternSchema,
        userDynamicPatternSchema: userDynamicPatternSchema,
    };
}
function _getPlatformPayload(adapter, itemData, seoData, isOriginalLang) {
    if (isOriginalLang === void 0) { isOriginalLang = true; }
    var platformLegacySeoOverrides = adapter.getLegacySeoBlob(itemData);
    var platformSchemaOverrides = seoData;
    return isOriginalLang
        ? [platformLegacySeoOverrides, platformSchemaOverrides]
        : [platformSchemaOverrides, platformLegacySeoOverrides];
}
export function getTags(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.siteLevelSeoData, siteLevelSeoData = _c === void 0 ? {} : _c, _d = _b.pageLevelSeoData, pageLevelSeoData = _d === void 0 ? {} : _d, _e = _b.veloOverrides, veloOverrides = _e === void 0 ? [] : _e, _f = _b.veloItemPayload, veloItemPayload = _f === void 0 ? getDefaultItemPayload() : _f, _g = _b.dynamicPageData, dynamicPageData = _g === void 0 ? [] : _g, _h = _b.tpaSeoEndpointData, tpaSeoEndpointData = _h === void 0 ? [] : _h, _j = _b.tpaOverrides, tpaOverrides = _j === void 0 ? [] : _j, _k = _b.componentsItemPayload, componentsItemPayload = _k === void 0 ? [] : _k, _l = _b.options, options = _l === void 0 ? { logError: function () { } } : _l;
    return __awaiter(this, void 0, void 0, function () {
        var siteLevelMetaTags, itemType, itemData, seoData, asNewPage, _m, defaultStaticPatternSchema, defaultDynamicPatternSchema, _o, userPatternSchema, userStaticPatternSchema, userDynamicPatternSchema, context, itemDataWithContext, adapter, platformPayload, staticPatterns, dynamicSchemaFromAdapter, hasMultilingualData, dynamicPatterns, payload, adaptedContext, multilingualTags, _p, componentsTags, componentContext, editorPanelPayload, resolvedTags;
        return __generator(this, function (_q) {
            switch (_q.label) {
                case 0:
                    siteLevelMetaTags = filterPageLevelTags(convertSiteLevelMetaTags(siteLevelSeoData.metaTags));
                    itemType = veloItemPayload.itemType, itemData = veloItemPayload.itemData, seoData = veloItemPayload.seoData, asNewPage = veloItemPayload.asNewPage;
                    return [4 /*yield*/, getDefaultPatternsSchemas(itemType)];
                case 1:
                    _m = _q.sent(), defaultStaticPatternSchema = _m[0], defaultDynamicPatternSchema = _m[1];
                    _o = _getUserPatternPayload(siteLevelSeoData, itemType, options), userPatternSchema = _o.userPatternSchema, userStaticPatternSchema = _o.userStaticPatternSchema, userDynamicPatternSchema = _o.userDynamicPatternSchema;
                    context = getContext(siteLevelSeoData, pageLevelSeoData, userPatternSchema);
                    itemDataWithContext = __assign(__assign({}, itemData), { context: context });
                    return [4 /*yield*/, getAdapter(itemType)];
                case 2:
                    adapter = _q.sent();
                    platformPayload = _getPlatformPayload(adapter, itemData, seoData, context[CONTEXT_PROPS.CURR_LANG_IS_ORIGINAL]);
                    staticPatterns = [defaultStaticPatternSchema, userStaticPatternSchema];
                    dynamicSchemaFromAdapter = getDynamicPatternsSchema(adapter, itemDataWithContext);
                    hasMultilingualData = hasAdapterMultilingualData(adapter, itemDataWithContext);
                    dynamicPatterns = [
                        defaultDynamicPatternSchema,
                        dynamicSchemaFromAdapter,
                        userDynamicPatternSchema,
                    ];
                    payload = [];
                    adaptedContext = __assign({}, adapter.getData(itemDataWithContext));
                    multilingualTags = !hasMultilingualData &&
                        getMultilingualSchemaFromContext(itemDataWithContext, {
                            translationsData: pageLevelSeoData === null || pageLevelSeoData === void 0 ? void 0 : pageLevelSeoData.translationsData,
                        });
                    if (!asNewPage) return [3 /*break*/, 3];
                    payload = __spreadArrays([
                        siteLevelMetaTags,
                        multilingualTags
                    ], staticPatterns, dynamicPatterns, platformPayload);
                    return [3 /*break*/, 6];
                case 3: return [4 /*yield*/, convertComponentsItemPayload({
                        componentsItemPayload: componentsItemPayload,
                        context: context,
                    })];
                case 4:
                    _p = _q.sent(), componentsTags = _p.componentsTags, componentContext = _p.componentContext;
                    return [4 /*yield*/, _getEditorPayload(context, pageLevelSeoData)];
                case 5:
                    editorPanelPayload = _q.sent();
                    adaptedContext = __assign(__assign({}, adaptedContext), componentContext);
                    payload = __spreadArrays([
                        siteLevelMetaTags,
                        multilingualTags
                    ], staticPatterns, editorPanelPayload, dynamicPatterns, componentsTags, [
                        dynamicPageData,
                        tpaSeoEndpointData,
                        tpaOverrides
                    ], platformPayload);
                    payload = [filterPayloadWithoutVelo(payload, veloOverrides), veloOverrides];
                    _q.label = 6;
                case 6:
                    resolvedTags = resolveWithPatterns(payload, adaptedContext, options);
                    return [2 /*return*/, handleOldBlog(resolvedTags, siteLevelSeoData)];
            }
        });
    });
}
